import {
    PluginMedia,
    PluginWorkSite,
} from 'rwl-shared/dist/models/plugin/Plugin';
import { createContext, useContext, useLayoutEffect, useState } from 'react';

export interface JobStoryContextProps {
    jobStoryId: string | undefined;
    setJobStoryId: (jobStoryId: string | undefined) => void;

    selectedMedia: PluginMedia | undefined;
    setSelectedMedia: (media: PluginMedia | undefined) => void;

    setSimilarJobs: (jobs: PluginWorkSite[] | undefined) => void;
    similarJobs: PluginWorkSite[] | undefined;
    clearJobStory: () => void;
}

export const JobStoryContext = createContext<JobStoryContextProps>(
    {} as JobStoryContextProps
);

export const JobStoryProvider = ({
    children,
    selectedSimilarJobs,
}: {
    children: React.ReactNode;
    selectedSimilarJobs?: PluginWorkSite[]; // Mostly used for testing..
}) => {
    const [jobStoryId, setJobStoryId] = useState<string>();
    const [selectedMedia, setSelectedMedia] = useState<
        PluginMedia | undefined
    >();
    const [similarJobs, setSimilarJobs] = useState<
        PluginWorkSite[] | undefined
    >();

    useLayoutEffect(() => {
        setSimilarJobs(selectedSimilarJobs);
    }, [selectedSimilarJobs]);

    return (
        <JobStoryContext.Provider
            value={{
                jobStoryId,
                setJobStoryId,
                selectedMedia,
                setSelectedMedia,
                similarJobs,
                setSimilarJobs,
                clearJobStory: () => {
                    setJobStoryId(undefined);
                    setSelectedMedia(undefined);
                    setSimilarJobs(undefined);
                },
            }}
        >
            {children}
        </JobStoryContext.Provider>
    );
};

export const useJobStory = () => {
    const context = useContext(JobStoryContext);
    if (context === undefined) {
        throw new Error('useJobStory must be used within a FilterProvider');
    }
    return context;
};
